import React, { useState } from 'react';
import styled from 'styled-components';
// import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface CodeBlockProps {
  code: string;
  language?: string;
}

const CodeBlock: React.FC<CodeBlockProps> = ({ language = 'bash', code }) => {
  return (
    <CodeWrapper>
      <SyntaxHighlighter
        language={language}
        showLineNumbers={true} // 라인 넘버 표시
        wrapLongLines={true} // 긴 줄 자동 줄바꿈
        wrapLines={true} // 줄바꿈
        lineProps={{ style: { wordBreak: 'break-all', whiteSpace: 'pre-wrap' } }}
        style={oneLight}
        customStyle={{
          fontSize: '12px',
          overflow: 'auto',
          height: '100%',
          margin: 0
        }}>
        {code}
      </SyntaxHighlighter>
    </CodeWrapper>
  );
};

export default CodeBlock;

const CodeWrapper = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  height: 264px;

  span {
    white-space: pre;
  }
`;
